import React from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import { Auth } from "aws-amplify";

import { Authentication } from "../context/AuthenticationContext";

export default class Newpassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      password: "",
      c_password: "",
      given_name: "",
      family_name: "",
      submitting: false
    };
  }

  onChangePassword = async user => {
    try {
      console.log(user);
      this.setState({ submitting: true });
      let result = await Auth.completeNewPassword(user, this.state.password, {
        given_name: this.state.given_name,
        family_name: this.state.family_name
      });

      await Auth.updateUserAttributes(user, {
        "custom:role": "ADMIN"
      });
      await Auth.verifyCurrentUserAttribute("email");
      this.props.history.push("/");
      console.log(result);
    } catch (error) {
      this.setState({ submitting: false });
      console.log(error);
    }
  };

  handleChange = fieldname => e => {
    this.setState({
      [fieldname]: e.target.value
    });
  };

  render() {
    return (
      <Authentication.Consumer>
        {context => {
          return (
            <Grid container direction="row" justify="center" alignItems="center" spacing={40}>
              <Grid item xs={12} sm={10} md={7}>
                <Paper style={{ marginTop: 50, padding: 20 }}>
                  <Typography variant="h4" gutterBottom style={{ textAlign: "center" }}>
                    Update your profile
                  </Typography>

                  <TextField
                    label="New Password"
                    margin="normal"
                    type="password"
                    style={{ width: "100%", fontSize: "80px" }}
                    variant="outlined"
                    value={this.state.password}
                    onChange={this.handleChange("password")}
                  />

                  <TextField
                    label="Confirm Password"
                    margin="normal"
                    type="password"
                    style={{ width: "100%", fontSize: "80px" }}
                    variant="outlined"
                    value={this.state.c_password}
                    onChange={this.handleChange("c_password")}
                  />

                  <TextField
                    label="Firstname"
                    margin="normal"
                    style={{ width: "100%", fontSize: "80px" }}
                    variant="outlined"
                    value={this.state.given_name}
                    onChange={this.handleChange("given_name")}
                  />

                  <TextField
                    label="Lastname"
                    margin="normal"
                    style={{ width: "100%", fontSize: "80px" }}
                    variant="outlined"
                    value={this.state.family_name}
                    onChange={this.handleChange("family_name")}
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.onChangePassword(context.state.user)}
                    disabled={this.state.submitting}
                  >
                    Submit {this.state.submitting && <CircularProgress size={12} color="primary" style={{ marginLeft: 5 }} />}
                  </Button>
                </Paper>
              </Grid>
            </Grid>
          );
        }}
      </Authentication.Consumer>
    );
  }
}
